import { DocIcon, ExcelIcon, TextFileIcon } from "../theme/icons";
import { PDFIcon2 } from "../theme/icons2";

export const truncateString = (filename, maxLength = 22) => {
  const extIndex = filename.lastIndexOf(".");
  const ext = filename.substring(extIndex);
  const name = filename.substring(0, extIndex);

  if (name.length <= maxLength) {
    return filename;
  }
  const truncatedName = name.substring(0, maxLength) + "...";
  return truncatedName + ext;
};

export const mimeTypes = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "docx",
  "application/vnd.ms-excel": "xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "application/zip": "zip",
  "application/json": "json",
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/gif": "gif",
  "text/plain": "txt",
  "text/html": "html",
  // Add more MIME types as needed
};

export const ImageTypes = {
  pdf: <PDFIcon2 />,
  xls: <ExcelIcon />,
  xlsx: <ExcelIcon />,
  docxt: <DocIcon />,
  doc: <DocIcon />,
  txt: <TextFileIcon />,
};

export const avoidDuplicateElementsFromArray = (array, key) => {
  const uniqueValues = [];
  const invoiceNos = new Set();
  array?.forEach((item) => {
    const filter = String(item?.[key]);
    if (!invoiceNos.has(filter)) {
      uniqueValues.push(item);
      invoiceNos.add(filter);
    }
  });
  return uniqueValues;
};
